import { PaginatedTable } from '@app/components/paginated-table';
import { TableProps } from '@app/components/table';
import { IRole } from '../types';
import { RoleRow } from './role-row';

interface Props {
  tableProps: TableProps;
  rows?: IRole[];
  loading: boolean;
  canAddRoles: string;
}

const RolesList = ({ tableProps, rows, loading, canAddRoles }: Props) => {
  const TABLE_HEAD = [
    { id: 'id', label: 'id', align: 'center' },
    { id: 'name', label: 'Name', align: 'center' },
    { id: 'status', label: 'Status', align: 'center', sortable: false },
    ...(canAddRoles ? [{ id: 'Action', label: 'Action', align: 'center', sortable: false }] : []),
  ];
  return (
    <PaginatedTable<IRole>
      head={TABLE_HEAD}
      tableProps={tableProps}
      data={rows}
      loading={loading}
      isServerSidePaging={false}
    >
      {(row) => <RoleRow row={row} canAddRoles={canAddRoles} />}
    </PaginatedTable>
  );
};

export default RolesList;
